import React from 'react'
import styles from './group.m.scss'
import { QuestionDefinition } from '../../questions.yml'
import { Question } from 'components/questionnaire/components/question'

interface Props {
  title: string
  questions: QuestionDefinition[]
  total: number
}

export function Group({ title, questions, total }: Props) {
  return (
    <div className={styles.group}>
      <h3 className={styles.title}>{title}</h3>

      {questions.map(q => (
        <Question {...q} key={q.header} total={total}/>
      ))}
    </div>
  )
}
